import * as types from "./types";
import { Widget } from "./actions";

type ReducerArgs = {
  type: string;
  payload: any;
};

export type WidgetSelectionStepReducer = {
  loading: boolean;
  widgets: Array<Widget>;
};

const initialState = {
  loading: false,
  widgets: [],
};

export default function (
  state = initialState,
  { type, payload }: ReducerArgs,
): WidgetSelectionStepReducer {
  switch (type) {
    case types.SET_LOADING:
      return { ...state, loading: payload as boolean };
    case types.SET_WIDGETS:
      return { ...state, widgets: payload as Array<Widget> };
    default:
      return state;
  }
}
